import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ion-padding-vertical ion-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.t('LoginPage.completeRegistration')), 1)
      ]),
      _createVNode(_component_ion_grid, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "10" }, {
                default: _withCtx(() => [
                  _createElementVNode("form", null, [
                    _createVNode(_component_ion_item, {
                      class: "ion-margin-bottom",
                      fill: "outline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('RegisterPage.nickname')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "text",
                          modelValue: _ctx.user.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      class: "ion-margin-bottom",
                      fill: "outline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('RegisterPage.email')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          inputmode: "email",
                          type: "text",
                          modelValue: _ctx.user.email,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.email) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      class: "ion-margin-bottom",
                      fill: "outline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('RegisterPage.inviteCode')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "text",
                          modelValue: _ctx.user.inviteCode,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.inviteCode) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_button, {
                      shape: "round",
                      expand: "block",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateUser()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('LoginPage.finish')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}